import { RouterModule } from '@angular/router';

export const SuicidalityRoutesModule = RouterModule.forChild([
]);
